import PropTypes from 'prop-types';
import React from 'react';

import { QuestionMarkCircleIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanyDownloadsDeleteModal = ({
  open = false,
  title = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={QuestionMarkCircleIcon} />
    <Modal.Title>Delete download</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete download: <b>{title}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'download_delete' }}
        data-test-id="company-downloads-deleteModal-delete"
      >
        Delete download
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanyDownloadsDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanyDownloadsDeleteModal;
